import React, { useEffect, useRef } from "react";
import { getCMSApiRoute } from "../api.util";
import axiosInstance from "@/config/axiosInstance";
import _ from 'lodash';

export function useGenreList({ fetchDelay = 0 } = {}) {
  const [items, setItems] = React.useState([]);
  const [hasMore, setHasMore] = React.useState(true);
  const [isLoading, setIsLoading] = React.useState(false);
  const init = useRef(false);
  const [page, setPage] = React.useState(1);
  const limit = 100; // Number of items per page, adjust as necessary

  const loadGenre = async (page) => {
    const controller = new AbortController();
    const { signal } = controller;

    try {
      setIsLoading(true);
      if (page > 1) {
        await new Promise((resolve) => setTimeout(resolve, fetchDelay));
      }

      const response = await axiosInstance.get(getCMSApiRoute("genre"), {
        params: {
          pageIndex: limit,
          pageNumber: page,
        },
        signal,
      });

      if (!response.statusText === "ok") {
        throw new Error("Network response was not ok");
      }

      const { data } = response.data;

      setHasMore(data.genres?.total > page * limit);
      setItems(
        _.uniqBy(
          [...items, ...data?.result.filter((x) => x.status === 1)],
          (x) => x._id
        )
      );
    } catch (error) {
      console.log(error);
      if (error.name === "AbortError") {
        console.log("Fetch aborted");
      } else {
        console.error("There was an error with the fetch operation:", error);
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (init.current === false) {
      init.current = true;
      loadGenre(page);
    }
  }, []);

  const onLoadMore = async () => {
    const newOffset = page + 1;

    setPage(newOffset);
    await loadGenre(newOffset);
  };

  return {
    items,
    hasMore,
    isLoading,
    onLoadMore,
  };
}
